<template>
    <div data-cy="container_mission_other">
        <div v-if="isComingSoon" data-cy="container_mission_other_coming_soon">
            <div class="flex flex-col my-auto justify-center items-center mt-20">
                <div class="text-16 text-center text-white pb-4">
                    {{ lbl.mission.mission_comingsoon }}
                </div>
                <div>
                    <img class="w-16" :src="imgUrl()" />
                </div>
            </div>
        </div>
        <div v-else>
            <MissionGame v-if="game" data-cy="component_mission_game" :game="game" />
            <MissionGamePuzzle v-if="gamePuzzle" data-cy="component_mission_game_puzzle" :game="gamePuzzle" />
            <MissionGameMatch v-if="gameMatch && isGameMatchPeriod" data-cy="component_mission_game_match" :game="gameMatch" />
            <MissionSurvey
                v-for="(dashboard, v) in surveyDashboard"
                :key="v"
                data-cy="component_mission_survey"
                :dashboard="dashboard"
                :index="v" />
        </div>
        <div class="scroll-overlay w-full max-w-500 fixed bottom-0 left-0 right-0 py-2 mx-auto" v-if="!isBottom && !isComingSoon">
            <div class="absolute left-0 right-0 bottom-28 flex justify-center align-middle text-14 text-a-white-ffffff">
                {{ lbl.mission.scroll_down }} <img class="pl-1" src="@/assets/icon/ic-scroll-down.svg" />
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import MissionGame from './MissionGame.vue';
import MissionGamePuzzle from './MissionGamePuzzle.vue';
import MissionGameMatch from './MissionGameMatch.vue';
import MissionSurvey from './MissionSurvey.vue';
//service
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
import { SubDashboardConfigBuilder } from '@/core/Campaign/config/DashboardConfigModel.js';
import MissionService from '../../service/MissionService.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//hepler
import DatetimeHelper from '@/helper/DatetimeHelper';

export default {
    name: "OtherMission",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        MissionGame,
        MissionGamePuzzle,
        MissionGameMatch,
        MissionSurvey,
    },
    data: function() {
        return {
            gameDashboard: null,
            surveyDashboard: null,
            gamePuzzleDashboard: null,
            gameMatchDashboard: null,

            isBottom: false,
            isComingSoon: true,
            isShowMissionGame: false,
            game: [],
            gamePuzzle: [],
            gameMatch: null,

            isGamePeriod: true,
            isGamePuzzlePeriod: true,
            isGameMatchPeriod: false,
        }
    },
    created: async function() {
        this.initialMission();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        initialMission: async function(){
            this.modal.loadingModal.show();
            this.gameDashboard = await this.getGameDashboard();
            this.gamePuzzleDashboard = await this.getGamePuzzleDashboard();
            this.gameMatchDashboard = await this.getGameMatchDashboard();
            this.surveyDashboard = await this.getSurveyDashboard();

            if(this.gameDashboard && this.gameDashboard.length > 0){
                this.isGamePeriod = this.checkIsPeriod()
            }else{
                this.isGamePeriod = false;
            }
            if (this.gamePuzzleDashboard && this.gamePuzzleDashboard.length > 0) {
                this.isGamePuzzlePeriod = this.checkIsPeriodPuzzle()
            }else{
                this.isGamePuzzlePeriod = false;
            }
            if (this.gameMatchDashboard && this.gameMatchDashboard.length > 0) {
                this.isGameMatchPeriod = this.checkIsPeriodMatch()
            }else{
                this.isGameMatchPeriod = false;
            }

            if(this.isGamePeriod || this.isGamePuzzlePeriod || this.isGameMatchPeriod){
                let findGame = await this.getGameConfig();
                
                if (findGame) {
                    console.log('findGame',findGame);
                    this.findMissionGame(findGame);
                }
            }

            await this.checkMissionOther();
            this.modal.loadingModal.hide();
            this.setScrollDown();
        },
        getGameDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gameDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });

        },
        getGamePuzzleDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gamePuzzleDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        getGameMatchDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().gameMatchDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            resolve(null);
                        }
                    });
            });
        },
        findMissionGame: function(find) {
            console.log('findMissionGame',find);
            if(find?.code == 404) return;
            
            this.game = find.find((item) => item.PartitionKey != 'puzzle' && item.PartitionKey != 'match');
            this.gamePuzzle = find.find((item) => item.PartitionKey == 'puzzle');
            this.gameMatch = find.find((item) => item.PartitionKey == 'match');
        },
        getSurveyDashboard: function() {
            return new Promise((resolve) => {
                let configBuilder = new SubDashboardConfigBuilder();
                configBuilder.setLocale(this.localeCode);

                let params = configBuilder.create().getParams();
                let dashboard = ConfigManager.getDashboardConfig().surveyDashboard;

                BzbsDashboard.apiGetSubDashboard(params, dashboard)
                    .subscribe({
                        next: (res) => {
                            //this.arrDashboardFlag1 = res;
                            this.isHaveItem = res.length > 0 ? true : false
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            console.log(err);
                            resolve(null);
                        }
                    });
            });

        },
        checkIsPeriod: function(){
            let now = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gameDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gameDashboard[0].endDate);

            if(now >= start && now <= end){
                return true;
            }
            return false;
        },
        checkIsPeriodPuzzle: function(){
            let now = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gamePuzzleDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gamePuzzleDashboard[0].endDate);

            if(now >= start && now <= end){
                return true;
            }
            return false;
        },
        checkIsPeriodMatch: function(){
            if (!this.gameMatchDashboard || this.gameMatchDashboard.length <= 0) {
                return false;
            }
            let now = new Date();
            let start = DatetimeHelper.unixTimestampToDate(this.gameMatchDashboard[0].startDate);
            let end = DatetimeHelper.unixTimestampToDate(this.gameMatchDashboard[0].endDate);

            if(now >= start && now <= end){
                return true;
            }
            return false;
        },
        getGameConfig: async function(){
            return new Promise((resolve)=>{
                this.modal.loadingModal.show();
                MissionService.getGameConfig().subscribe({
                    next: (res)=>{
                        this.modal.loadingModal.hide();
                        resolve(res.data)
                    },
                    error: (err)=>{
                        console.log('err',err);
                        this.modal.loadingModal.hide();
                        resolve(err)
                    }
                })
            })
        },
        checkMissionOther: function() {
            return new Promise((resolve) =>{
                if (this.surveyDashboard && this.surveyDashboard.length == 0 && this.isGamePeriod == false && this.isGamePuzzlePeriod == false && this.isGameMatchPeriod == false) {
                    this.isComingSoon = true;
                } else if (this.surveyDashboard && this.surveyDashboard.length == 0 && this.isGamePeriod == true && this.isGamePuzzlePeriod == true) {
                    this.isBottom = true;
                    this.isComingSoon = false;
                } else {
                    this.isBottom = false;
                    this.isComingSoon = false;
                }

                resolve(true);
            })

        },
        setScrollDown: function() {
            window.onscroll = () => {
                const clientHeight = document.documentElement.clientHeight;
                const scrollHeight = document.documentElement.scrollHeight;
                const scrollTop = document.documentElement.scrollTop;

                if (scrollTop + clientHeight >= scrollHeight-58) {
                    this.isBottom = true;
                }else{
                    this.isBottom = false;
                }

            };
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-coming-soon.png`;
        },
    }

}
</script>
<style lang="scss" scoped>
.bg-mission-detail {
    //background-color: rgb(255, 253, 228);
    height: 100vh;
    .bg-mission {
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        .bg-point {
            .img-point {
                width: 100%;
                height: 101px;
                margin: auto;
            }
        }
        .bg-checkin {
            max-width: 200px;
        }
    }

    .bg-mission-item{
        min-height: 144px;
        background-image: linear-gradient(to right, #1a63c9 22%, #2140a6 65%);
    }

    .scroll-overlay{
        height: 205px;
        background-image: linear-gradient(to top, #000, rgba(84, 84, 84, 0));
    }
}
</style>
